"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setReporter = void 0;
let reporter = globalThis.console;
const setReporter = (nextReporter = globalThis.console) => {
    reporter = nextReporter;
};
exports.setReporter = setReporter;
exports.default = ['log', 'warn', 'error', 'time', 'timeEnd', 'perf'].reduce((acc, type) => {
    acc[type] = (...args) => {
        if (reporter && typeof reporter[type] === 'function') {
            reporter[type](...args);
        }
    };
    return acc;
}, {});
//# sourceMappingURL=reporter.js.map